import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { url } from '../../../../services/url'
import axios from 'axios'

const endpoint = `${url}/patient/total_active_inactive`

export const getactivePatient = createAsyncThunk('get_active_patient', async () => {
  const response = await axios.get(endpoint)
  return response
})

export const active_patient = createSlice({
  name: 'active_patient',
  initialState: {
    data: [],
    status: 'READY',
    total: 1,
    params: {},
    selected: null,
    error: '',
    sendFilter: {
      statusText: '',
      payload: ''
    }
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getactivePatient.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.status = 'READY'
      })
      .addCase(getactivePatient.pending, (state) => {
        state.data = true
        state.status = 'PENDING'
      })
  }
})

export default active_patient.reducer